// src/pages/buyer-leads.jsx
import MainBuyerLeads from "../components/buyer-leads/main-buyer-leads";

function BuyerLeads() {
  return (
    <div>
      <MainBuyerLeads />
    </div>
  );
}

export default BuyerLeads;
